import { createSelector } from '@reduxjs/toolkit';
import { getOrganization } from '../organization/getOrganization';
import { getPartners } from './get-partners';

import { toList } from '../toList';

export const partnersWithContacts = createSelector(getOrganization, getPartners, function (m, partners) {
  if (m) {
    const contacts = toList(m.contactsById);
    return partners.map(function (p) {
      return Object.assign({}, p, {
        contacts: contacts.filter(function (c) {
          return c.partnerUuid === p.uuid;
        }),
      });
    });
  } else {
    return [];
  }
});
